module.exports = __webpack_public_path__ + "media/music/fad59dd220562492e6722aa8a97f9369.mp3";